/**
 * @module experience/hardgoods
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
/* tslint:disable: max-file-line-count*/
// Core
import { Component, Input, OnDestroy, Output, OnInit, EventEmitter } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { Wove } from 'aspect.js/';

// Services
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
import { CommonUtilService } from '@support/shared/services/common-util.service';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';

// Interfaces
import { ConfigData } from '@experience/repdash/interfaces/aem-content.interface';
import {
  DeviceDetails,
  CurrentDeviceDetails,
  ProductDescription,
} from '@experience/shop/hardgoods/interfaces/browse-hardgood.interface';
import { HardgoodsContent } from '@core/aem/interfaces/shop/browse-hardgoods.interface';
import {
  PricingOptions,
  ItemDetail,
  MemoryOption,
  DeviceSimInfo,
} from '@support/api/common/product.interface';

// Constants
import { HARDGOODS_MODULE_COMPONENTS } from '@experience/shop/hardgoods/constants/hardgoods.constants';
import {
  AVAILABILITY,
  HARDGOODS_CONSTANTS,
} from '@experience/shop/hardgoods/constants/browse-hardgoods.constants';

// Model
import { BrowseDeviceModel } from '@experience/shop/hardgoods/models/browse-device.model';
// import { SETTINGS, CHANNELS } from '@environment/settings';
import { CartSupportService } from '@support/cart-support/services/cart-support.service';
import { ProductTypes } from '@experience/shop/product-details/interfaces/product-details.interface';
import {
  LineDeivceDetails,
  lineTypeEnum,
} from '@experience/shop/product-selector/interfaces/product-selector.interface';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Cart } from '@support/api/proxies/responses/api-cart-response.interface';
import { TileManagementService } from '@support/shared/services/tile-management.service';
import { APIError } from '@support/api/common/error.interface';
import { StaticModal } from '@support/shared/widgets/interfaces/static-modal.interface';
import { PRODUCT_OFFERINGS_CONSTANTS } from '@core/aem/components/product-offerings/product-offerings.constants';
import { AddDeviceToNonLineItemsRequestModel } from 'app/model/add-nonline-device-request.model';
import { PERMISSION_CONSTANTS } from '@support/shared/constants/permission.constants';
import { SHARED_BROWSE_CONSTANTS } from '@experience/shop/shared-browse/constants/shared-browse.constants';
import { FAN } from '@support/api/proxies/responses/api-2038.interface';
import {
  CustomerAccountBillingDetails,
  LineSummary,
} from '@support/api/proxies/responses/api-2006.interface';
import { UserService } from '@support/shared/services/user.service';
import { ProductDetailsDefaultModel } from '@experience/shop/shared-browse/models/productDetails-default.model';
import { FeatureToggleUtilService } from '@support/shared/services/feature-toggle-util.service';

@Wove({ moduleName: HARDGOODS_MODULE_COMPONENTS.HARDGOODS_MODULE_NAME })
@Component({
  selector: 'tmo-retail-browse-hardgood',
  templateUrl: './retail-browse-hardgood.component.html',
  styleUrls: [
    '../../../../../../style-sheets/components/new-accordian.component.scss',
    '../../../../../../style-sheets/components/browse-device-accordian.component.scss',
  ],
  providers: [CurrencyPipe],
})
export class RetailBrowseHardgoodComponent implements OnInit, OnDestroy {
  /**
   * Content Data for browse devices
   */
  @Input() public contentData: HardgoodsContent;
  /**
   * stores browse hard goods contants
   */
  public browseDeviceConstants: ConfigData;
  /**
   * stores hardGood data
   */
  @Input() public hardGoodDetails: BrowseDeviceModel;
  /**
   * stores imageURL of selected color
   */
  public imageUrl: string;
  /**
   * Stores existing lines in account
   */
  public cartExistingLines: LineSummary[];
  /**
   * variable to show modal
   */
  public displayUpgradeMultilineModal: boolean;
  /**
   * To store current Device Details
   */
  public currentDeviceDetails: CurrentDeviceDetails;
  /**
   * To store availability Status Device
   */
  public availabilityStatus: string;
  /**
   * Stores formated strike through price value
   */
  public strikeThroughPrice: string;
  /**
   * Holds focused Tile Id Details
   */
  public focusedTileIdDetails: LineDeivceDetails;
  /**
   * Holds the value of allowEdit boolean
   */
  public allowEdit: boolean;
  /**
   * boolean to check if user is editing non line device in upgrade device flow
   */
  public isEditingNonLineDevice: boolean;
  /**
   * will hold without Qualifying Plan text
   */
  public withoutQualifyingPlan: string;
  /**
   * will check for sale
   */
  public onSale: boolean;
  /**
   * will check for deal
   */
  public hasDeal: boolean;
  /**
   * will have deal text
   */
  public dealText: string;
  /**
   * stores value for additional device charges
   */
  public additionalChargesWithDevice: string;
  /**
   * Stores the pricing options for EPin scenario
   */
  public pricingOptions: PricingOptions[];
  /**
   * Stores current index
   */
  @Input() public index: number;
  /**
   * Stores devices toggled state data
   */
  @Input() public toggleDetails: boolean[];
  /**
   * Stores device details at current index
   */
  @Output() public deviceDetailIndex: EventEmitter<object>;
  /**
   * Stores the error message from API
   */
  @Output() public apiError: EventEmitter<APIError[]>;
  /**
   * Stores color toolTip toggle state
   */
  public colorToolTip: boolean;
  /**
   * Stores memory toolTip toggle state
   */
  public memoryToolTip: boolean;
  /**
   * stores value of store status
   */
  public isStoreOpen: boolean;
  /**
   * string value to stores formatted price text
   */
  public strikeThroughPriceText: string;
  /**
   * variable to store memory array
   */
  public memoryOptions: MemoryOption[];
  /**
   * Holds ngUnsubscribe Object
   */
  private ngUnsubscribe: Subject<void>;
  /**
   * Holds the details for mixedCartModal
   */
  public mixedCartModal: StaticModal;
  /**
   * Holds if mixedCart is there
   */
  public mixedCart: boolean;
  /**
   * boolean to check if user is editing line device in upgrade device flow
   */
  public isEditingUpgradeLine: boolean;
  /**
   * boolean to hold if user is in device upgrade flow
   */
  public isUpgradeFlow: boolean;
  /**
   * Holds boolean if rep has permission to add second line or not
   */
  public hasPermissionToAddALine: boolean;
  /**
   * Holds Error Message
   */
  public errorMessage: APIError[];
  /**
   * Holds boolean to show or hide spinner
   */
  public showSpinner: boolean;
  /**
   * Holds availablity constants
   */
  public availabilityStatusConstant: ConfigData;
  /**
   *
   */
  public existingLineDetailsAvailable: boolean;
  /**
   * holds value of p10m flag
   */
  @Input() public isP10MCustomer: boolean;
  /**
   * check if user authenticated
   */
  public isAuthFlow: boolean;
  /**
   * check if user authenticated
   */
  public disableCta: boolean;
  /**
   * Boolean varible to hold feature flag value
   */
  public esimActivationsEnabled: boolean;
  constructor(
    private currencyPipe: CurrencyPipe,
    private stateStoreUtilService: StateStoreUtilsService,
    private objectService: ObjectService,
    private commonUtils: CommonUtilService,
    private cartSupportService: CartSupportService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private tileManagementService: TileManagementService,
    public featureToggleUtilService: FeatureToggleUtilService
  ) {
    this.deviceDetailIndex = new EventEmitter();
    this.apiError = new EventEmitter();
    this.currentDeviceDetails = {};
    this.colorToolTip = false;
    this.memoryToolTip = false;
    this.displayUpgradeMultilineModal = false;
    this.ngUnsubscribe = new Subject<void>();
    this.focusedTileIdDetails = this.tileManagementService.getFocusedTileIdDetails();
    this.availabilityStatusConstant = AVAILABILITY;
    const guestCheck =
      this.stateStoreUtilService.getCustomerId() === SHARED_BROWSE_CONSTANTS.ANON ||
      this.stateStoreUtilService.getCustomerId() === SHARED_BROWSE_CONSTANTS.EMPTY_STRING;
    this.isAuthFlow =
      this.stateStoreUtilService.getCustomerId() &&
      !this.stateStoreUtilService.getAddFan() &&
      !guestCheck;
    this.esimActivationsEnabled = this.featureToggleUtilService.isEsimActivationsEnabled();
  }

  /**
   * Method used to initialize data
   * @returns void
   */
  public ngOnInit(): void {
    this.disableCta =
      this.stateStoreUtilService.getInstoreFlow() ||
      !this.objectService.get(this.stateStoreUtilService.getShipFulfillment(), 'shipTo', true);
    this.createModal();
    const postTillStatus = this.stateStoreUtilService.getPOSVirtualTillStatus();
    // this.isStoreOpen = !(SETTINGS.CHANNEL.toLowerCase() === CHANNELS.RETAIL
    //   && (!this.stateStoreUtilService.getStoreStatus() || !postTillStatus));
    this.isStoreOpen = postTillStatus;
    this.loadInitialData();
    this.strikeThroughPriceText = this.commonUtils.messageFormatter(
      this.objectService.get(this.contentData, 'wasPrice'),
      [this.strikeThroughPrice]
    );
    this.hasPermissionToAddALine =
      this.cartSupportService.checkForAddALinePermission(PERMISSION_CONSTANTS.DEVICE_PDP) ||
      this.allowEdit;
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params: Params) => {
        this.isEditingNonLineDevice = params.isEditingNonLineDevice === 'true';
        this.isEditingUpgradeLine = params.isEditingUpgradeLine === 'true';
        this.isUpgradeFlow = params.isUpgrade === 'true' || this.isEditingUpgradeLine;
        if (
          this.objectService.get(params, 'bannerAdDesc') ||
          this.objectService.get(params, 'globalSearch')
        ) {
          this.updateDeviceDetails(0);
        }
      });
    this.allowEdit = this.activatedRoute.snapshot.queryParams.allowEdit === 'true';
  }
  /**
   * Method used to initialize model data
   * @returns void
   */
  public loadInitialData(): void {
    this.browseDeviceConstants = HARDGOODS_CONSTANTS;
    this.currentDeviceDetails = this.initalizeImages();
    this.memoryOptions = this.getMemoryOptions();
    // this.getSelectedMemoryVarient(this.currentDeviceDetails.memory);
    this.getAvailabilityStatus();
    let selectedItemDetails = this.hardGoodDetails.itemDetails.find(
      (deviceDetails: DeviceDetails) => {
        return deviceDetails.isDefaultSKU;
      }
    );
    selectedItemDetails = selectedItemDetails
      ? selectedItemDetails
      : this.hardGoodDetails.itemDetails[0];
    this.pricingOptions = this.commonUtils.sortUtil(
      this.hardGoodDetails.pricingOptions,
      HARDGOODS_CONSTANTS.SKU_PRICE,
      true,
      [],
      true
    );
    this.fetchCurrentDeviceData(selectedItemDetails);
  }

  /**
   * Method invoked on click of color swatch
   * @param colorId string
   * @returns void
   */
  public selectColor(colorId: string, colorName: string, index: number): void {
    const selectedItem = this.hardGoodDetails.itemDetails.find((item: DeviceDetails) => {
      return item.id.toString() === colorId;
    });
    this.colorToolTip = false;
    this.setSelectedColor(selectedItem, index);
  }

  /**
   * Method invoked on click of SIM Type selector
   * @param simInfo passes selected DeviceSimInfo
   * @param index of sim info
   */
  public selectSimInfo(simInfo: DeviceSimInfo, index: number): void {
    this.stateStoreUtilService.setSelectedSimInfo(simInfo);
    this.currentDeviceDetails.simInfo = simInfo;
    this.updateDeviceDetails(index);
  }

  /**
   * Method invoked on click of memory swatch
   * @param memoryId
   * @returns void
   */
  public setSelectedMemory(memoryId: string, index: number): void {
    const selectedMemoryItem = this.hardGoodDetails.product.itemDetails.filter(
      (item: ItemDetail) => {
        return item.memory === memoryId;
      }
    );
    this.memoryToolTip = false;
    const selectedColor = this.currentDeviceDetails.colorName;
    selectedMemoryItem &&
      selectedMemoryItem.forEach((item: ItemDetail, index: number) => {
        this.hardGoodDetails.setItemDetails(item, true, index);
      });
    this.currentDeviceDetails = this.initalizeImages();
    const selectedColorItem = this.hardGoodDetails.itemDetails.find((item: DeviceDetails) => {
      return item.memory === memoryId && selectedColor === item.colorName;
    });
    if (selectedColorItem) {
      this.fetchCurrentDeviceData(selectedColorItem);
    }
    this.updateDeviceDetails(index);
  }
  /**
   * Method invoked on click of color swatch
   * @param selectedDevice
   * @returns void
   */
  public setSelectedColor(selectedDevice: DeviceDetails, index: number): void {
    if (selectedDevice) {
      this.fetchCurrentDeviceData(selectedDevice);
      this.updateDeviceDetails(index);
    }
  }

  /**
   * Method invoked on page init and selectColorMethod
   * @param selectedDevice
   * @returns void
   */
  public fetchCurrentDeviceData(selectedDevice: DeviceDetails): void {
    if (selectedDevice) {
      this.currentDeviceDetails.uSkuIndicator = this.objectService.get(
        selectedDevice,
        'uSkuIndicator'
      );
      this.currentDeviceDetails.colorName = this.objectService.get(selectedDevice, 'colorName');
      this.currentDeviceDetails.imageUrl = this.objectService.get(selectedDevice, 'imageUrl');
      this.currentDeviceDetails.memory = this.objectService.get(selectedDevice, 'memory');
      this.currentDeviceDetails.simInfo = this.objectService.get(selectedDevice, 'simInfo');
      this.currentDeviceDetails.colorSwatchId = this.objectService.get(selectedDevice, 'id');
      this.currentDeviceDetails.availabilityStatus = this.objectService.get(
        selectedDevice,
        'availabilityStatus'
      );
      this.currentDeviceDetails.estimatedShippingFromDateTime = this.objectService.get(
        selectedDevice,
        'estimatedShippingFromDateTime'
      );
      this.currentDeviceDetails.estimatedShippingToDateTime = this.objectService.get(
        selectedDevice,
        'estimatedShippingToDateTime'
      );
      this.currentDeviceDetails.strikeThroughPrice = this.objectService.get(
        selectedDevice,
        'strikeThroughPrice'
      );
      this.currentDeviceDetails.payNowPrice = this.objectService.get(selectedDevice, 'payNowPrice');
      this.currentDeviceDetails.averageOverallRating = this.objectService.get(
        this.hardGoodDetails,
        'averageOverallRating'
      );
      this.currentDeviceDetails.id = this.objectService.get(selectedDevice, 'id');
      this.currentDeviceDetails.serviceThreshold = this.objectService.get(
        selectedDevice,
        'serviceThresholdPrice'
      );
      this.onSale = this.objectService.get(selectedDevice, 'hasSale');
      this.hasDeal = this.objectService.get(selectedDevice, 'hasDeal');
      this.currentDeviceDetails.promotionDescription = this.objectService.get(
        selectedDevice,
        'promotionDescription'
      );
      const listPrice = this.currencyPipe.transform(
        this.objectService.get(selectedDevice, 'salesPriceWithOutService'),
        'USD',
        'symbol-narrow',
        '1.2-2'
      );
      const serviceThresholdPrice = this.currencyPipe.transform(
        this.objectService.get(selectedDevice, 'serviceThresholdPrice'),
        'USD',
        'symbol-narrow',
        '1.2-2'
      );
      this.setContentData(serviceThresholdPrice, listPrice);
      this.strikeThroughPrice = this.currencyPipe.transform(
        this.currentDeviceDetails.strikeThroughPrice,
        'USD',
        'symbol-narrow',
        '1.2-2'
      );
      this.getAvailabilityStatus();
      this.setDefaultSimInfo();
    }
  }

  /**
   * Method used to update index for device toggled
   * @returns void
   */
  public updateIndex(idx: number): void {
    if (this.toggleDetails && this.toggleDetails.length) {
      for (let i = 0; i < this.toggleDetails.length; i++) {
        this.toggleDetails[i] = i === idx ? !this.toggleDetails[i] : false;
      }
    }
    this.updateDeviceDetails(idx);
  }

  /**
   * Method used to set AEM data for browse devices
   * @returns void
   */
  public setContentData(serviceThresholdPrice: string, listPrice: string): void {
    if (this.contentData) {
      this.browseDeviceConstants = HARDGOODS_CONSTANTS;
      this.additionalChargesWithDevice = this.commonUtils.messageFormatter(
        this.contentData.additionalChargesWithDevice,
        [listPrice]
      );

      if (serviceThresholdPrice && listPrice) {
        this.withoutQualifyingPlan = this.commonUtils.messageFormatter(
          this.contentData.withoutServicePriceDisclaimer,
          [serviceThresholdPrice.toString()]
        );
      }
    }
  }

  /**
   * method to check if auth flow
   */
  public checkExistingLines(overrideIndicator?: string): void {
    if (this.isAuthFlow && !this.isP10MCustomer) {
      this.showSpinner = true;
      this.getExistingLineDetails(overrideIndicator);
    } else {
      this.routeToProductSelector(overrideIndicator);
    }
  }

  /**
   * method to redirect to Hardgoods PDP
   * @returns void
   */
  public routeToProductSelector(overrideIndicator?: string): void {
    const lineId = this.stateStoreUtilService.getSelectedUpgradeLineId();
    if (!lineId && this.isUpgradeFlow) {
      this.showMultilineUpgradeModal();
    } else {
      const productTypeEnum = ProductTypes.HARDGOOD;
      const epinConflictData = this.cartSupportService.isEpinConflictWithCart(
        false,
        productTypeEnum
      );
      if (
        !(
          this.objectService.get(epinConflictData, 'hasConflict') ||
          this.objectService.get(epinConflictData, 'hasOnlyByos')
        )
      ) {
        this.showSpinner = true;
        if (
          (this.objectService.get(this.focusedTileIdDetails, 'plansFromCart.cartItemId') &&
            this.allowEdit &&
            !this.isP10MCustomer) ||
          this.isUpgradeFlow
        ) {
          if (this.isEditingNonLineDevice) {
            this.converNonLineItemToLineItem(overrideIndicator);
          } else {
            this.updateDeviceToCurrentPlan(overrideIndicator);
          }
        } else {
          this.postDeviceAsNonLineItem(overrideIndicator);
        }
      }
    }
  }

  /**
   * Method used to destroy data, subscriptions
   * @returns void
   */
  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /**
   * @name setDisplayModel
   * @returns void
   * @description sets the model to bind values on HTML on initial load or on click of color swatch
   */
  // tslint:disable-next-line: cyclomatic-complexity
  private initalizeImages(): CurrentDeviceDetails {
    const deviceDetails = this.hardGoodDetails.itemDetails.find((item: DeviceDetails) => {
      return item.isDefaultSKU;
    });
    const productType = this.hardGoodDetails.productType;
    this.stateStoreUtilService.setProductType(productType);
    let currentDeviceDetails: CurrentDeviceDetails = {};
    currentDeviceDetails = {
      imageUrl:
        this.objectService.get(deviceDetails, 'imageUrl') ||
        this.objectService.get(this.hardGoodDetails, 'itemDetails.0.imageUrl'),
      availabilityStatus:
        this.objectService.get(deviceDetails, 'availabilityStatus') ||
        this.objectService.get(this.hardGoodDetails, 'itemDetails.0.availabilityStatus'),
      colorSwatchId:
        this.objectService.get(deviceDetails, 'id') ||
        this.objectService.get(this.hardGoodDetails, 'itemDetails.0.id'),
      colorName:
        this.objectService.get(deviceDetails, 'colorName') ||
        this.objectService.get(this.hardGoodDetails, 'itemDetails.0.colorName'),
      memory:
        this.objectService.get(deviceDetails, 'memory') ||
        this.objectService.get(this.hardGoodDetails, 'itemDetails.0.memory'),
      payNowPrice:
        this.objectService.get(deviceDetails, 'payNowPrice') ||
        this.objectService.get(this.hardGoodDetails, 'itemDetails.0.payNowPrice'),
      promotionDescription:
        this.objectService.get(deviceDetails, 'promotionDescription') ||
        this.objectService.get(this.hardGoodDetails, 'itemDetails.0.promotionDescription'),
      estimatedShippingFromDateTime:
        this.objectService.get(deviceDetails, 'estimatedShippingFromDateTime') ||
        this.objectService.get(this.hardGoodDetails, 'itemDetails.0.estimatedShippingFromDateTime'),
      estimatedShippingToDateTime:
        this.objectService.get(deviceDetails, 'estimatedShippingToDateTime') ||
        this.objectService.get(this.hardGoodDetails, 'itemDetails.0.estimatedShippingToDateTime'),
      deviceSimInfo:
        this.objectService.get(deviceDetails, 'deviceSimInfo') ||
        this.objectService.get(this.hardGoodDetails, 'itemDetails.0.deviceSimInfo'),
    };
    return currentDeviceDetails;
  }

  /**
   * Function to get availability status
   * @returns void
   */
  private getAvailabilityStatus(): void {
    let isAvailable = true;
    this.availabilityStatus = this.objectService.get(
      this.currentDeviceDetails,
      `availabilityStatus`
    );
    switch (this.availabilityStatus) {
      case AVAILABILITY.IN_STOCK:
        this.availabilityStatus = this.objectService.get(this.contentData, 'inStock');
        break;
      case AVAILABILITY.LIMITEDAVAILABILITY:
        this.availabilityStatus = this.objectService.get(this.contentData, 'limitedAvailability');
        break;
      case AVAILABILITY.BACKORDERED:
        this.availabilityStatus = this.objectService.get(this.contentData, 'backordered');
        break;
      case AVAILABILITY.OUT_OF_STOCK:
        this.availabilityStatus = this.objectService.get(this.contentData, 'outOfStock');
        isAvailable = false;
        break;
      default:
        this.availabilityStatus = this.objectService.get(
          this.currentDeviceDetails,
          `availabilityStatus`
        );
    }
  }

  /**
   * Method to get memory option
   * @return MemoryOption[]
   */
  private getMemoryOptions(): MemoryOption[] {
    const memoryOpt =
      this.hardGoodDetails.memoryOptions && this.hardGoodDetails.memoryOptions.length
        ? this.hardGoodDetails.memoryOptions.map((memory: MemoryOption) => {
            return {
              name: this.getMemoryValue(memory.value),
              value: memory.value,
              available: memory.available,
            };
          })
        : null;
    return memoryOpt;
  }

  /**
   * Method to get MemoryValue
   * @return string
   */
  private getMemoryValue(memoryValue: string): string {
    const memoryType = memoryValue.split(' ');
    return memoryType[0];
  }
  /**
   * Method to call API for cart line Item
   * @param overrideIndicator
   */
  private converNonLineItemToLineItem(overrideIndicator?: string): void {
    const cartItemId = this.objectService.get(
      this.focusedTileIdDetails,
      'selectedDevice.cartItemId'
    );
    const lineId = this.stateStoreUtilService.getSelectedUpgradeLineId();
    const newSku = this.objectService.get(this.currentDeviceDetails, 'colorSwatchId');
    const newOfferId = this.stateStoreUtilService.getSelectedOfferId();
    const cart = this.stateStoreUtilService.getCart();
    const transactionType = this.objectService.get(cart, 'orderType');
    this.cartSupportService
      .updateCartLevelDeviceToLineLevel(
        cartItemId,
        null,
        lineId,
        newSku,
        newOfferId,
        transactionType,
        null,
        overrideIndicator
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: Cart) => {
          this.showSpinner = false;
          this.stateStoreUtilService.setUpgradeFlow(true);
          this.tileManagementService.mapToCartResponse(data);
          this.tileManagementService.deleteLine();
          this.setExisitingTileInFocus();
          this.navigateToProductSelector(true);
        },
        (error: APIError[]) => {
          this.errorMessage = error;
          this.apiError.emit(error);
          this.showSpinner = false;
        }
      );
  }

  /**
   * Function used to get existing line details
   */
  private getExistingLineDetails(overrideIndicator?: string): void {
    this.existingLineDetailsAvailable = true;
    this.cartSupportService
      .getExistingLineDetails()
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe(
        (cart: FAN) => {
          this.existingLineDetailsAvailable = false;
          this.hasPermissionToAddALine = this.cartSupportService.checkForAddALinePermission(
            PERMISSION_CONSTANTS.DEVICE_PDP
          );
          this.routeToProductSelector(overrideIndicator);
        },
        (error: APIError[]) => {
          this.errorMessage = error;
          this.apiError.emit(error);
          this.existingLineDetailsAvailable = false;
        }
      );
  }

  /**
   * function to display multiline upgrade modal
   * @returns void
   */
  private showMultilineUpgradeModal(): void {
    this.userService
      .getCustomerAccountBillingSummary()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response: CustomerAccountBillingDetails) => {
          this.cartExistingLines = this.objectService.get(response, `lines`);
          if (this.objectService.get(this.cartExistingLines, `length`) > 1) {
            this.displayUpgradeMultilineModal = true;
          } else if (this.objectService.get(this.cartExistingLines, `length`) === 1) {
            const lineId = this.objectService.get(this.cartExistingLines, `0.lineOfServiceId`);
            this.stateStoreUtilService.setSelectedUpgradeLineId(lineId);
            this.routeToProductSelector();
          }
        },
        (error: APIError[]) => {
          this.errorMessage = error;
          this.apiError.emit(error);
        }
      );
  }

  /**
   * Close upgrade modal on click of cross button
   * @return void
   */
  public closeUpgradeModal(): void {
    this.displayUpgradeMultilineModal = false;
  }

  /**
   * Function to update line selected on multiline model
   * @param productDetails ProductDetails
   * @param isDeviceUpgrade boolean
   * @returns void
   */
  public updateUpgradeLineSelected(): void {
    this.displayUpgradeMultilineModal = false;
    this.routeToProductSelector();
  }

  /**
   * Function to update device details for current line in focus
   */
  private updateDeviceToCurrentPlan(overrideIndicator?: string): void {
    if (this.isUpgradeFlow) {
      this.deleteNonLineTileWithoutDevice();
      this.setExisitingTileInFocus();
    }
    this.cartSupportService
      .updateLineDevice(
        this.currentDeviceDetails.colorSwatchId.toString(),
        this.hardGoodDetails.offerId,
        this.isUpgradeFlow,
        null,
        null,
        null,
        overrideIndicator,
        this.currentDeviceDetails.uSkuIndicator,
        'SHIPTO',
        this.allowEdit
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: Cart) => {
          this.showSpinner = false;
          if (this.isUpgradeFlow) {
            this.stateStoreUtilService.setUpgradeFlow(this.isUpgradeFlow);
          }
          this.tileManagementService.mapToCartResponse(data);
          this.navigateToProductSelector(this.isUpgradeFlow);
        },
        (error: APIError[]) => {
          this.showSpinner = false;
          if (error[0].code === 'BIZ_0001_INVALID_TRANS_TYPE') {
            this.mixedCart = true;
            this.mixedCartModal.toggleModalEmitter.emit({ open: true, close: false });
          } else {
            this.errorMessage = error;
            this.apiError.emit(error);
          }
        }
      );
  }

  /**
   * Function to add device as non line item
   */
  private postDeviceAsNonLineItem(overrideIndicator?: string): void {
    this.showSpinner = true;
    if (this.isEditingUpgradeLine) {
      const cartItemId = this.objectService.get(
        this.focusedTileIdDetails,
        'deviceDetails.cartItemId'
      );
      const lineId = this.objectService.get(this.focusedTileIdDetails, 'lineId');
      const newSku = this.objectService.get(this.currentDeviceDetails, 'colorSwatchId');
      const newOfferId = this.stateStoreUtilService.getSelectedOfferId();
      const cart = this.stateStoreUtilService.getCart();
      const transactionType = this.objectService.get(cart, 'orderType');
      this.cartSupportService
        .updateLineLevelDeviceToCartLevel(
          cartItemId,
          lineId,
          newSku,
          newOfferId,
          transactionType,
          PRODUCT_OFFERINGS_CONSTANTS.UPGRADE_DEVICE,
          overrideIndicator
        )
        .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
        .subscribe(
          (cartData: Cart) => {
            this.objectService.set(this.focusedTileIdDetails, 'selectedDevice', null);
            this.objectService.set(this.focusedTileIdDetails, 'isUpgrade', false);
            this.stateStoreUtilService.setFocusedTileLineNonLineItem(this.focusedTileIdDetails);
            this.tileManagementService.createTile(lineTypeEnum.NONLINE, true);
            this.processNonLineItemCartResponse(cartData);
          },
          (error: APIError[]) => {
            this.showSpinner = false;
            if (error[0].code === 'BIZ_0001_INVALID_TRANS_TYPE') {
              this.mixedCart = true;
              this.mixedCartModal.toggleModalEmitter.emit({ open: true, close: false });
            } else {
              this.errorMessage = error;
              this.apiError.emit(error);
            }
          }
        );
    } else {
      const skuItemCollection = [];
      const skuItem = new AddDeviceToNonLineItemsRequestModel();
      skuItem.setSkuDetails(
        this.currentDeviceDetails.colorSwatchId.toString(),
        this.hardGoodDetails.offerId
      );
      skuItemCollection.push(skuItem.getDeviceInfo());
      this.cartSupportService
        .postDeviceAsNonLineItem(
          skuItemCollection,
          this.allowEdit,
          null,
          null,
          overrideIndicator,
          this.currentDeviceDetails.uSkuIndicator,
          'SHIPTO',
          this.allowEdit
        )
        .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
        .subscribe(
          (cartData: Cart) => {
            if (!this.allowEdit) {
              const hasPermissionToAddALine =
                this.hasPermissionToAddALine &&
                !(
                  this.objectService.get(this.focusedTileIdDetails, 'lineTileType') ===
                    lineTypeEnum.NONLINE &&
                  this.objectService.get(this.focusedTileIdDetails, 'isLineSetupCompleted')
                );
              const noPlanNeeded = this.stateStoreUtilService.getUpgradeFlow()
                ? true
                : this.cartSupportService.isMaxLineReached() || !hasPermissionToAddALine;
              this.tileManagementService.createTile(lineTypeEnum.NONLINE, noPlanNeeded);
            }
            this.processNonLineItemCartResponse(cartData);
          },
          (error: APIError[]) => {
            this.showSpinner = false;
            if (error[0].code === 'BIZ_0001_INVALID_TRANS_TYPE') {
              this.mixedCart = true;
              this.mixedCartModal.toggleModalEmitter.emit({ open: true, close: false });
            } else {
              this.errorMessage = error;
              this.apiError.emit(error);
            }
          }
        );
    }
  }

  /*
   * Function to process the cart responce once item is added as non line
   * @param cartData Cart
   */
  private processNonLineItemCartResponse(cartData: Cart): void {
    this.stateStoreUtilService.setSelectedItemInPDP(this.currentDeviceDetails);
    this.tileManagementService.setNonLineItemDetails(cartData);
    this.errorMessage = null;
    this.apiError.emit(null);
    this.showSpinner = false;
    this.navigateToProductSelector();
  }

  /**
   * Function used to navigate to product selector
   */
  private navigateToProductSelector(isDeviceUpgrade?: boolean): void {
    let tileId;
    if (this.allowEdit || isDeviceUpgrade) {
      const losId = this.stateStoreUtilService.getSelectedUpgradeLineId();
      tileId =
        isDeviceUpgrade && this.tileManagementService.getExisitingLineTileId(losId)
          ? this.tileManagementService.getExisitingLineTileId(losId)
          : this.stateStoreUtilService.getFocusedTileId();
      const details = this.stateStoreUtilService.getFocusedTileLineNonLineItem(tileId);
      details.isUpgrade = isDeviceUpgrade;
      this.stateStoreUtilService.setFocusedTileId(tileId);
      this.stateStoreUtilService.setFocusedTileLineNonLineItem(details);
    } else {
      const nonItemTileIdList = this.stateStoreUtilService.getTileIdList(lineTypeEnum.NONLINE);
      tileId = nonItemTileIdList.slice(-1)[0];
      this.stateStoreUtilService.setFocusedTileId(tileId);
    }
    this.setProductDetails();
    if (!this.isP10MCustomer) {
      const shipTo = this.objectService.get(
        this.stateStoreUtilService.getShipFulfillment(),
        'shipTo',
        true
      );
      if (!this.cartSupportService.shouldNavigateToPlanServices(shipTo)) {
        this.router.navigate([PRODUCT_OFFERINGS_CONSTANTS.NAVIGATE_TO_PRODUCT_SELECTOR, tileId]);
      }
    } else {
      this.router.navigate([PRODUCT_OFFERINGS_CONSTANTS.CART]);
    }
  }
  /**
   * to set the product details
   */
  private setProductDetails(): void {
    this.stateStoreUtilService.setSelectedOfferId(this.hardGoodDetails.offerId);
    const selectedColor = this.stateStoreUtilService.getSelectedColor();
    const productDetailsModel = new ProductDetailsDefaultModel(
      this.hardGoodDetails.product,
      this.objectService,
      selectedColor,
      this.commonUtils,
      this.hardGoodDetails.product.itemDetails
    );
    this.stateStoreUtilService.setSelectedDeviceDetails(
      productDetailsModel,
      this.hardGoodDetails.offerId
    );
  }

  /**
   * to set the details of tile in focus on the basis of existing line LoS ID
   */
  private setExisitingTileInFocus(): void {
    const losId = this.stateStoreUtilService.getSelectedUpgradeLineId();
    const tileId = this.tileManagementService.getExisitingLineTileId(losId);
    this.stateStoreUtilService.setFocusedTileId(tileId);
    this.focusedTileIdDetails = this.tileManagementService.getFocusedTileIdDetails();
  }
  /**
   * Function to initialize mixed cart modal details
   */
  private createModal(): void {
    this.mixedCartModal = {
      headerText: this.objectService.get(this.contentData, 'clearYourCart'),
      bodyText: this.objectService.get(this.contentData, 'clearOrViewCart'),
      disableDismiss: true,
      disableEsc: true,
      modalName: 'mixed-cart-modal',
      buttons: [
        {
          id: this.objectService.get(this.contentData, 'continue'),
          type: 'submit',
          name: this.objectService.get(this.contentData, 'continue'),
          class: 'btn btn-primary',
        },
        {
          id: 'ViewCart',
          type: 'cancel',
          name: this.objectService.get(this.contentData, 'viewCart'),
          class: 'btn btn-secondary',
        },
      ],
      toggleModalEmitter: new EventEmitter(),
      dismissableMask: false,
    };
  }
  /**
   * method to handle event on click of continue in mixed cart modal
   * @returns void
   */
  public handleClickEvent(event: Event): void {
    this.mixedCartModal.toggleModalEmitter.emit({
      open: false,
      close: true,
    });
    const key = 'id';
    const id = event[key];
    if (id === this.objectService.get(this.contentData, 'continue')) {
      this.routeToProductSelector('true');
    } else if (id === this.objectService.get(this.contentData, 'viewCart')) {
      this.mixedCart = false;
      this.router.navigate([HARDGOODS_CONSTANTS.CART_URL]);
    }
  }

  /**
   * Function used to remove white space
   * @param {string} name
   * @returns {string}
   */
  public getColorName(name: string = ''): string {
    return name.replace(/\s/g, '').toLowerCase();
  }

  /**
   * Method to update device details
   * @return void
   * @param null
   */
  private updateDeviceDetails(idx: number): void {
    const details: ProductDescription = {
      index: idx,
      deviceDetails: this.currentDeviceDetails,
    };
    this.deviceDetailIndex.emit(details);
  }

  /**
   * Set default SIM Info for selected device based on isDefault attribute
   */
  private setDefaultSimInfo(): void {
    if (this.currentDeviceDetails.deviceSimInfo && !this.currentDeviceDetails.simInfo) {
      this.currentDeviceDetails.simInfo = this.currentDeviceDetails.deviceSimInfo.find(
        (sim: DeviceSimInfo) => sim.isDefault === true
      );
      this.selectSimInfo(this.currentDeviceDetails.simInfo, 0);
    }
  }

  /**
   * Function to delete non line tile if it does not have a device associated with it
   */
  private deleteNonLineTileWithoutDevice(): void {
    const lineDetails = this.tileManagementService.getFocusedTileIdDetails();
    const lineTileType = this.objectService.get(lineDetails, 'lineTileType');
    const cartItemId = this.objectService.get(lineDetails, 'selectedDevice.cartItemId');
    if (lineTileType === lineTypeEnum.NONLINE && !cartItemId) {
      this.tileManagementService.deleteLine();
    }
  }
}
